import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authRepository } from '../../infrastructure/authApiRepository';
import '../styles/auth.css';

export function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get('token');
    const [status, setStatus] = useState('loading'); // loading | success | error

    useEffect(() => {
        if (!token) { setStatus('error'); return; }
        authRepository.verifyEmail(token)
            .then(() => setStatus('success'))
            .catch(() => setStatus('error'));
    }, [token]);

    return (
        <div className="verify-page">
            <div className="verify-card">
                {status === 'loading' && (
                    <>
                        <div className="verify-card__icon">⏳</div>
                        <div className="verify-card__title">인증 중입니다...</div>
                        <p className="verify-card__desc">잠시만 기다려주세요.</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <div className="verify-card__icon">✅</div>
                        <div className="verify-card__title">이메일 인증 완료!</div>
                        <p className="verify-card__desc">
                            이메일 인증이 완료되었습니다.<br />
                            이제 로그인하실 수 있습니다.
                        </p>
                        <Link to="/login" className="auth-submit" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', lineHeight: '52px' }}>
                            로그인 하러 가기
                        </Link>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <div className="verify-card__icon">❌</div>
                        <div className="verify-card__title">인증 링크가 유효하지 않습니다</div>
                        <p className="verify-card__desc">
                            링크가 만료되었거나 이미 사용된 링크입니다.<br />
                            다시 가입하시거나 고객센터에 문의해주세요.
                        </p>
                        <Link to="/register" className="auth-submit" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', lineHeight: '52px' }}>
                            회원가입 다시 하기
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
